import { render, staticRenderFns } from "./Commonheader.vue?vue&type=template&id=2081c36c"
import script from "./Commonheader.vue?vue&type=script&lang=js"
export * from "./Commonheader.vue?vue&type=script&lang=js"
import style0 from "./Commonheader.vue?vue&type=style&index=0&id=2081c36c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports